"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appName = {
    passenger: 'passenger',
    driver: 'driver',
    didies: 'didies',
    daijia: 'daijia',
    finance: 'finance',
    kflowerDriver: 'kflowerDriver',
    kflowerPassenger: 'kflowerPassenger',
    globalDriver: 'globalDriver',
    globalPassenger: 'globalPassenger',
    xiaojuchefu: 'xiaojuchefu',
    shunfengche: 'shunfengche',
    qingjuchelian: 'qingjuchelian',
    driverFreight: 'driverFreight'
};
exports.otherName = {
    weixin: 'weixin',
    alipay: 'alipay'
};
exports.allName = __assign({}, exports.appName, exports.otherName);
